import axios from "axios";
import { getApi, getTables, getCookie, getBrowserInfo, isTableOccasional } from "../helpers/Pipes";
import { Simulation } from "../hooks/simulationData";
import { isProd } from "../helpers/Pipes";

export const useApi = () => {
    const _api = getApi();
    const _tables = getTables();
    const _simulatoreCodes = _tables.simulatore.codes;
    const _simulatoreParams = _tables.simulatore.params;

    const _buildCodes = (codesArr) => {
        return codesArr.join(",");
    };

    const _buildParams = (paramsObj) => {
        return Object.keys(paramsObj)
            .map((key) => key + "=" + paramsObj[key])
            .join("&");
    };

    const _response = (endpoint, method = "get", payload = {}) => {
        return new Promise((success, reject) => {
            try {
                axios[method](endpoint, payload)
                    .then((res) => {
                        if (res.status != 200) {
                            reject("KO");
                        } else {
                            success(res.data);
                        }
                    })
                    .catch((err) => {
                        reject("KO");
                    });
            } catch (error) {
                reject("KO");
            }
        });
    };

    /* Endpoints */
    const getProntuario = () => {
        // if (isProd()) {
        //     return _response(`https://api.mycompass.app/compass/prontuario/${_buildCodes(_simulatoreCodes)}&${_buildParams(_simulatoreParams)}`, "get");
        // } else {
        //     return _response(`${_api.base}${_api.prontuario}?tab=${_buildCodes(_simulatoreCodes)}&${_buildParams(_simulatoreParams)}`, "get");
        // }
        return _response(`${_api.base}${_api.prontuario}?tab=${_buildCodes(_simulatoreCodes)}&${_buildParams(_simulatoreParams)}`, "get");
    };

    const checkUserData = (payload = {}) => {
        return _response(`${_api.base}${_api.doppietta}`, "post", payload);
    };

    const goToP1M = (payload = {}) => {
        return _response(`${_api.base}${_api.goToP1M}`, "post", payload);
    };

    const otpCheck = (payload = {}) => {
        return _response(`${_api.base}${_api.otpCheck}`, "post", payload);
    };

    const getFinalStepPayload = () => {
        const payload = {
            CODICE_APP: "SIMCOMM",
            MOD_PAGAMENTO: "RI",
            SC_TIPO_OFFERTA: "1",
            SC_RICALCOLO: "N",
            CODICE_OFFERTA: isTableOccasional() ? "DGS_DF_PRO" : "DGS_DF_WEB",
            URL_RITORNO: window.location.href,
            SC_BACKURL: window.location.href,
            // dynamic
            SC_IMPORTO_RATA: "" + Simulation.get("rataValue"),
            SC_NUMERO_RATE: "" + Simulation.get("maxDurata"),
            SC_IMPORTO_TOTALE: "" + Simulation.get("importo"),
            SC_BENE: Simulation.get("purpose"),
            SC_BENE_DESCR: Simulation.get("purposeTitle"),
            BROWSER_INFO: getBrowserInfo(),
            // cookies
            UTM_SOURCE: getCookie("utm_source"),
            UTM_CONTENT: getCookie("utm_content"),
            UTM_TERM: getCookie("utm_term"),
            UTM_CAMPAIGN: getCookie("utm_campaign"),
            UTM_DATE: getCookie("utm_date"),
            MEDIACODE: localStorage.getItem("newmediacode") || "",
            UTM_HISTORY: localStorage.getItem("media_history") || "",
            gclid: localStorage.getItem("gclid") || "",
            // new
            EsitoOTP: Simulation.get("EsitoOTP") || "",
        };

        return payload;
    };

    const finalStep = (payload = {}) => {
        const pl = {
            ...getFinalStepPayload(),
            ...payload,
        };
        return _response(`${_api.finalStep}`, "post", pl);
    };

    const logToGrafana = async (motivo, httpstatusrisposta, payloadRichiesta, evento) => {
        const headers = {
            "X-Forward-To": "logger",
            "X-Application-Name": `simulatore2022${isProd() ? "" : "-coll"}`,
        };
        await axios.post("https://res.mycompass.app", `evento="${evento}" motivo="${motivo}" httpstatusrisposta=${httpstatusrisposta} payloadRichiesta=${payloadRichiesta.toString()}`, {
            headers,
        });
        return;
    };

    const disaster = async (motivo, httpstatusrisposta, payloadRichiesta, evento = "redirect su FA3") => {
        await logToGrafana(motivo, httpstatusrisposta, payloadRichiesta, evento);
        window.location.href = "/fa3/?utm_source=DS&utm_campaign=ResDaily&mediacode=4492";
    };

    const pingSapient = () => {
        return axios.get("https://api.appcenter.it/compass/testSapient");
    };

    return {
        getProntuario,
        checkUserData,
        otpCheck,
        finalStep,
        disaster,
        pingSapient,
        logToGrafana,
        getFinalStepPayload,
        goToP1M,
    };
};
